import { combineReducers } from 'redux';

import reports from './reports/reducer';

export default combineReducers({
    reports,
});


// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/state/reducer.js